module.exports = __webpack_public_path__ + "tf.0d1af327084bc6ef9fe2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tf.svg
// module chunks = styles